import { EntityType } from '@frontend/common';
import { useResolver } from '@frontend/repository';
import { WizardClient } from '@frontend/wizard/api';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';

declare global {
    interface WindowEventMap {
        'useWizard:request': CustomEvent<string>;
    }
}

const REQUEST_WIZARD_EVENT = 'useWizard:request';
const STORAGE_KEY = 'WIZ_REQ';

export function wizardRequest(wizardId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_WIZARD_EVENT, { detail: wizardId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function WizardResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_WIZARD_EVENT, EntityType.WIZARD, (ids) => WizardClient.resolveWizards(ids), props.dispatch);
    return <></>;
}
